import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DattaConfig } from '../app-config';

import { Gioithieu } from '../model/quanlythongtin/gioithieu';
import { Huongdan } from '../model/quanlythongtin/huongdan';
import { Thongtincanbiet } from '../model/quanlythongtin/thongtincanbiet';
import { Phananhkiennghi } from '../model/quanlythongtin/phananhkiennghi';
import { Thongtinluuy} from '../model/quanlythongtin/thongtinluuy';
import { Thongtinluuychitiet} from '../model/quanlythongtin/thongtinluuychitiet';
import { Dmtinhthanh } from '../model/quanlythongtin/Dmtinhthanh';
import { Dmhuyenthi } from '../model/quanlythongtin/Dmhuyenthi';
import { Dmphuongxa } from '../model/quanlythongtin/Dmphuongxa';

@Injectable({
  providedIn: 'root'
})
export class QlttPhananhkiennghiService {
  public dattaConfig: any;
  token: string;

  httpOptions : any;
  constructor(private httpClient: HttpClient) {
    this.dattaConfig = DattaConfig.config;   
  }

  ngOnInit(): void {   
  }

  //start gioithieu
  getGioithieus() {
    return this.httpClient.get<Gioithieu[]>(this.dattaConfig['httplink'] + '/gioithieu/get');
  }

  getGioithieutheodonvis(id) {
    return this.httpClient.get<Gioithieu[]>(this.dattaConfig['httplink'] + '/gioithieu/get/'+id);
  }

  addGioithieu(entity: Gioithieu) {
    return this.httpClient.post<Gioithieu>(this.dattaConfig['httplink'] + '/gioithieu/add', entity);
  }

  updateGioithieu(entity: Gioithieu){
    return this.httpClient.post<Gioithieu>(this.dattaConfig['httplink'] + '/gioithieu/update', entity);
  }

  deleteGioithieu(id) {
    return this.httpClient.delete<Gioithieu>(this.dattaConfig['httplink'] + '/gioithieu/'+id);
  }
  //end gioi thieu

  //huong dan
  getHuongdans() {
    return this.httpClient.get<Huongdan[]>(this.dattaConfig['httplink'] + '/huongdan/get');
  }

  getHuongdantheodonvis(id) {
    return this.httpClient.get<Huongdan[]>(this.dattaConfig['httplink'] + '/huongdan/get/'+id);
  }

  addHuongdan(entity: Huongdan) {
    return this.httpClient.post<Huongdan>(this.dattaConfig['httplink'] + '/huongdan/add', entity);
  }
  deleteHuongdan(id) {
    return this.httpClient.delete<Huongdan>(this.dattaConfig['httplink'] + '/huongdan/' + id);
  }
  updateHuongdan(entity: Huongdan) {
    return this.httpClient.put<Huongdan>(this.dattaConfig['httplink'] + '/huongdan/update', entity);
  }
  //End huong dan

  //thong tin can biet
  getThongtincanbiets() {
    return this.httpClient.get<Thongtincanbiet[]>(this.dattaConfig['httplink'] + '/thongtincanbiet/get');
  }
  addThongtincanbiet(entity: Thongtincanbiet) {
    return this.httpClient.post<Thongtincanbiet>(this.dattaConfig['httplink'] + '/thongtincanbiet/add', entity);
  }
  deleteThongtincanbiet(id) {
    return this.httpClient.delete<Thongtincanbiet>(this.dattaConfig['httplink'] + '/thongtincanbiet/' + id);
  }
  updateThongtincanbiet(entity: Thongtincanbiet) {
    return this.httpClient.put<Thongtincanbiet>(this.dattaConfig['httplink'] + '/thongtincanbiet/update', entity);
  }
  //End thong tin can biet

    //phan anh kien nghi
    getPhananhkiennghis() {
      return this.httpClient.get<Phananhkiennghi[]>(this.dattaConfig['httplink'] + '/phananhkiennghi/get');
    }

    getPhananhkiennghitheodonvis(id) {
      return this.httpClient.get<Phananhkiennghi[]>(this.dattaConfig['httplink'] + '/phananhkiennghi/get/'+id);
    }

    addPhananhkiennghi(entity: Phananhkiennghi) {
      return this.httpClient.post<Phananhkiennghi>(this.dattaConfig['httplink'] + '/phananhkiennghi/add', entity);
    }
    deletePhananhkiennghi(id) {
      return this.httpClient.delete<Phananhkiennghi>(this.dattaConfig['httplink'] + '/phananhkiennghi/' + id);
    }
    updatePhananhkiennghi(entity: Phananhkiennghi) {
      return this.httpClient.put<Phananhkiennghi>(this.dattaConfig['httplink'] + '/phananhkiennghi/update', entity);
    }

    updateread(id: number) {
      return this.httpClient.get(this.dattaConfig['httplink'] + `/phananhkiennghi/updateread/${id}`);
    }
    //End phan anh kien nghi

    //begin dongbo PAKN
    syncDataPAKNDiaPhuongid(id) {
      return this.httpClient.get(this.dattaConfig['httplink'] + '/phananhkiennghi/syncDataPAKNDiaPhuong/'+id);
    }
    syncPAKNQuocGiaChoXuLy() {
      return this.httpClient.get(this.dattaConfig['httplink'] + '/phananhkiennghi/syncPAKNQuocGiaChoXuLy');
    }
    syncPAKNQuocGiaCongKhai() {
      return this.httpClient.get(this.dattaConfig['httplink'] + '/phananhkiennghi/syncPAKNQuocGiaCongKhai');
    }
    syncDataPAKNDiaPhuong(ids:Array<Number>) {
      return this.httpClient.post(this.dattaConfig['httplink'] + '/phananhkiennghi/syncDataPAKNDiaPhuongList',ids);
    }
    //End dongbo PAKN

    //thong tin luu y

    getDsThongtinluuy() {    
      return this.httpClient.get<Thongtinluuy[]>(this.dattaConfig['httplink'] + '/ttluuy');
    }
  
    getDsThongtinluuytheodonvi(id) {    
      return this.httpClient.get<Thongtinluuy[]>(this.dattaConfig['httplink'] + '/ttluuy/findbydonvi/'+id);
    }
  
    
    getThongtinluuy(id) {
      return this.httpClient.get<Thongtinluuy>(this.dattaConfig['httplink'] + '/ttluuy/get/' +id);
    }
    addThongtinluuy(item: Thongtinluuy) {
       
      return this.httpClient.post<Thongtinluuy>(this.dattaConfig['httplink'] + '/ttluuy/add' , item);
    }
    deleteThongtinluuy(id) {
      return this.httpClient.delete<Thongtinluuy>(this.dattaConfig['httplink'] + '/ttluuy/' + id);
    }
  
    updateThongtinluuy(item: Thongtinluuy) {
      return this.httpClient.put<Thongtinluuy>(this.dattaConfig['httplink'] + '/ttluuy/update', item);
    }
  
    //dscauhoitraloi
    getDsTTLuuyChitiet(id) {
      
      return this.httpClient.get<Thongtinluuychitiet[]>(this.dattaConfig['httplink'] + '/ttluuy/getttluuychitiet/' + id);
    }
    addTTLuuyChitiet(item: Thongtinluuychitiet) {
       
      return this.httpClient.post<Thongtinluuychitiet>(this.dattaConfig['httplink'] + '/ttluuy/addttluuychitiet' , item);
    }
    deleteTTLuuyChitiet(id) {
      return this.httpClient.delete<Thongtinluuychitiet>(this.dattaConfig['httplink'] + '/ttluuy/delttluuychitiet/' + id);
    }
  
    updateTTLuuyChitiet(item: Thongtinluuychitiet) {
      return this.httpClient.put<Thongtinluuychitiet>(this.dattaConfig['httplink'] + '/ttluuy/updatettluuychitiet', item);
    }
  
    //end thong tin luu y


    //ttqhpx
    getListTinhthanh() {
      return this.httpClient.get<Dmtinhthanh[]>(this.dattaConfig['httplink'] + '/layout/tinhthanh/getcohieuluc');
    }
    getQuanhuyenByTTId(provinceId: number) {
      return this.httpClient.get<Dmhuyenthi[]>(this.dattaConfig['httplink'] + '/layout/huyenthi/getid/' + provinceId);
    }
    getListQuanHuyen() {
      return this.httpClient.get<Dmhuyenthi[]>(this.dattaConfig['httplink'] + '/layout/huyenthi/get');
    }
    getXaByQuanHuyenID(districtId: number) {
      return this.httpClient.get<Dmphuongxa[]>(this.dattaConfig['httplink'] + '/layout/phuongxa/getid/' + districtId);
    }
    getListPhuongxa() {
      return this.httpClient.get<Dmphuongxa[]>(this.dattaConfig['httplink'] + '/layout/phuongxa/get');
    }
}